/*
设备完好率--按月呈现
 */
import React, { Component } from "react";
import Echarts from "echarts";
import moment from "moment";
import { getRateMonth } from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";

class StubMonth extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      choosedDay: moment(new Date()).subtract(0, "d").format("YYYY-MM-DD"),
      choosedMonth: moment(new Date()).subtract(0, "d").format("YYYY-MM"),
      cityId: this.props.param.cityId,
      operationProperty: this.props.param.operationProperty,
      operationMode: this.props.param.operationMode,
      type: this.props.param.type,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`; // + second + "秒";
    } else if (hour > 0) {
      return `${hour}时${minute}分`; // + second + "秒";
    } else if (minute > 0) {
      return `${minute}分`; // + second + "秒";
    } else {
      return `${second}秒`;
    }
  }

  /**
   * 初始化页面方法
   */
  componentDidMount() {
    this.init();
  }

  componentWillMount() {}

  // 获取接口数据方法
  init() {
    this.queryStubOperationModeInfo();
  }

  // 调用接口获取数据
  queryStubOperationModeInfo() {
    fetchHandler(getRateMonth, {
      type: this.state.type,
      cityId: this.state.cityId,
      operationProperty: this.state.operationProperty,
      operationMode: this.state.operationMode,
    }).then((res) => {
      if (res) {
        const day = this.props.param.date;
        this.setState(
          {
            stubData: res.data,
            choosedDay: day,
            choosedMonth: moment(this.props.param.date).format("YYYY-MM"),
          },
          () => {
            this.stubIntactChart();
          },
        );
      }
    });
  }

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentWillReceiveProps(nextProps) {
    /**
     * preDataMonth ： 原选择月份
     * nextDataMonth ： 改变后选择月份
     */
    const preDataMonth = this.state.choosedMonth;
    const nextDataMonth = moment(nextProps.param.date).format("YYYY-MM");

    /**
     * 判断相关参数是否改变
     */
    if (
      preDataMonth === nextDataMonth
      && this.props.param.cityId === nextProps.param.cityId
      && this.props.param.type === nextProps.param.type
      && this.props.param.operationProperty === nextProps.param.operationProperty
      && this.props.param.operationMode === nextProps.param.operationMode
    ) {
      /**
       * 参数未改变，直接返回，不继续执行后续方法
       */
      return;
    }

    /**
     * 判断除月份外其他参数是否改变
     */
    if (
      this.props.param.cityId === nextProps.param.cityId
      && this.props.param.type === nextProps.param.type
      && this.props.param.operationProperty === nextProps.param.operationProperty
      && this.props.param.operationMode === nextProps.param.operationMode
    ) {
      /**
       * 未改变，重置图表，定位到选择月份
       */

      console.log(nextProps.param);
      const day = nextProps.param.date;
      this.setState(
        {
          choosedDay: day,
          choosedMonth: moment(nextProps.param.date).format("YYYY-MM"),
        },
        () => {
          this.stubIntactChart();
        },
      );
    } else {
      /**
       * 参数改变，调用接口获取参数，重置图表
       */
      this.setState(
        {
          cityId: nextProps.param.cityId,
          operationProperty: nextProps.param.operationProperty,
          operationMode: nextProps.param.operationMode,
          type: nextProps.param.type,
          // time:moment(nextProps.param.date).format('YYYY-MM')
        },
        () => {
          this.queryStubOperationModeInfo();
        },
      );
    }
  }

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart() {
    const dataArry = [...this.state.stubData]; // 接口获取数据
    const year = parseInt(this.state.choosedDay.split("-")[0]); // 当前年分
    const month = parseInt(this.state.choosedDay.split("-")[1]); // 当前月份

    // 设置X轴
    const xAxisData = dataArry.map((item) => {
      const date = `${item.date}01`;
      const monthInfo = moment(date).format("YYYY-MM");
      return monthInfo;
    });

    // 设置完好率数据
    const intactData = dataArry.map((item) => {
      const foo = {
        value: item.intactRate,
        info: {
          value: this.handleSecord(
            parseInt(
              (item.totalOperationDuration
                - item.totalErrorDuration - item.totalOfflineDuration) / item.stubCnt,
            ),
          ),
          name: "平均完好时长",
        },
      };
      return foo;
    });

    // 设置离线率数据
    const offlineData = dataArry.map((item) => {
      const foo = {
        value: item.offlineRate,
        info: {
          value: this.handleSecord(parseInt(item.totalOfflineDuration / item.stubCnt)),
          name: "平均离线时长",
        },
      };
      return foo;
    });

    // 设置故障率数据
    const errorData = dataArry.map((item) => {
      const foo = {
        value: item.errorRate,
        info: {
          value: this.handleSecord(parseInt(item.totalErrorDuration / item.stubCnt)),
          name: "平均故障时长",
        },
      };
      return foo;
    });
    // 设置可用率数据
    const availableData = dataArry.map((item) => {
      const foo = {
        value: item.availableRate,
        info: {
          value: this.handleSecord(parseInt(item.totalAvailableDuration / item.availableCnt)),
          name: "平均可用时长",
        },
      };
      return foo;
    });

    // 设置设备总数数据
    const stubNumData = dataArry.map((item) => {
      return item.stubCnt;
    });

    // 设置可用桩
    const availableStubData = dataArry.map((item) => {
      return item.availableCnt;
    });

    // 设置右侧y轴最大值
    const maxY1 = parseInt(Math.max(...availableStubData) / 10) * 1.25 * 10;

    const myChart = Echarts.init(document.getElementById("chart3"));
    const option = {
      color: ["#e5323e", "#0000CD", "#6B8E23", "#FFD700", "#5B8FF9", "#5AD8A6"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: (param) => {
          let toolInfo = "";

          const names = param.map((v) => v.seriesName);
          const index1 = names.findIndex((v) => v === "可用设备总数");
          const index2 = names.findIndex((v) => v === "完好设备总数");
          const includesName1 = names.includes("可用设备总数");
          const includesName2 = names.includes("完好设备总数");

          if (includesName1 && !includesName2) {
            toolInfo = `可用设备总数: ${param[index1].value}`;
          } else if (includesName2 && !includesName1) {
            toolInfo = `完好设备总数: ${param[index2].value}`;
          } else if (includesName1 && includesName2) {
            toolInfo = `可用设备总数:${param[index1].value},完好设备总数:${param[index2].value}`;
          }

          param.map((item) => {
            if (item.seriesName !== "可用设备总数" && item.seriesName !== "完好设备总数") {
              const msg = `<div> ${item.data.info.name}:${item.data.info.value}, ${item.seriesName}:${item.value}%</div>`;
              toolInfo += msg;
            }
            return true;
          });
          return toolInfo;
        },
      },
      legend: {
        data: [
          "完好率",
          "离线率",
          "故障率",
          "可用率",
          {
            name: "可用设备总数",
            icon: "circle",
          },
          {
            name: "完好设备总数",
            icon: "circle",
          },
        ],
      },
      dataZoom: {
        // type: 'inside',
        showDetail: false,
        startValue: (year - 2020) * 12 + month - 6,
        endValue: (year - 2020) * 12 + month + 7,
        maxValueSpan: 11,
        handleIcon:
          "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "40%",
        handleStyle: {
          color: "#fff",
          shadowBlur: 3,
          shadowColor: "rgba(0, 0, 0, 0.6)",
          shadowOffsetX: 2,
          shadowOffsetY: 2,
        },
      },
      grid: {
        left: "50px",
        right: "70px",
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          name: "",
          // x轴文字倾斜
          axisLabel: {
            interval: 0,
            margin: 2,
            textStyle: {
              fontWeight: "bolder",
              color: "#000000",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: "{value} %",
          },
        },
        {
          type: "value",
          name: "设备数量",
          interval: Math.ceil(maxY1 / 10),
          min: 0,
          max: maxY1,
          axisLabel: {
            formatter: "{value}",
          },
        },
      ],
      series: [
        {
          name: "完好率",
          type: "line",
          yAxisIndex: 0,
          data: intactData,
        },
        {
          name: "离线率",
          type: "line",
          yAxisIndex: 0,
          data: offlineData,
        },
        {
          name: "故障率",
          type: "line",
          yAxisIndex: 0,
          data: errorData,
        },
        {
          name: "可用率",
          type: "line",
          yAxisIndex: 0,
          data: availableData,
        },
        {
          name: "可用设备总数",
          type: "bar",
          // barWidth:availableStubData.lenght>20?20:38,
          yAxisIndex: 1,
          barGap: 0,
          data: availableStubData,
        },
        {
          name: "完好设备总数",
          type: "bar",
          // barWidth:stubNumData.lenght>20?20:38,
          yAxisIndex: 1,
          barGap: 0,
          data: stubNumData,
        },
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
        // this.stubIntactChart();
      },
    };
    console.log(option);
    myChart.clear();
    myChart.setOption(option);
    // 图例选中状态事件
    myChart.on("legendselectchanged", () => {});
    // 判断选中月份，的index
    // let indexD = xAxisData.indexOf(this.state.choosedMonth)
    // console.log(indexD)
    // console.log(this.state.choosedMonth)
    // console.log(xAxisData)
    // myChart.dispatchAction({
    //     type:'showTip',
    //     seriesIndex:0,
    //     dataIndex:indexD,
    //     position:['50%','50%']
    // })

    // 图表中柱状图点击执行，修改选择月份，传递至父组件
    myChart.on("click", (obj) => {
      console.log(moment(xAxisData[obj.dataIndex]).format("YYYY-MM"));
      this.setState(
        {
          choosedMonth: moment(xAxisData[obj.dataIndex]).format("YYYY-MM"),
        },
        () => {
          this.props.changeMonth(xAxisData[obj.dataIndex]);
        },
      );
    });
  }

  render() {
    return (
      <div className='analysis-content-3'>
        <div style={{ width: "100%", height: 420, overflowY: "auto" }} id='chart3'></div>
      </div>
    );
  }
}

export default StubMonth;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubMonth.js